import { useQuery } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '@/components';

import { WeekEventsWidget } from '../../components/Widgets';
import { GetWidgetDocument } from '../_internal/Widget.query.generated';

const WidgetWeekEvents = () => {
  const router = useRouter();

  const getWidget = useQuery(GetWidgetDocument, {
    variables: {
      widgetId: Number(router.query.widgetId),
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !router.query.widgetId,
    context: {
      role: 'anonymous',
    },
  });
  const widget = getWidget.data?.widgets_widget_by_pk;

  const teams = widget?.team_detail_list;

  return (
    <WidgetsApp widget={widget}>
      <WeekEventsWidget
        teams={teams}
        sort={widget?.sort}
        clubId={widget?.content_club_id || widget?.club_id}
        daySwitch={widget?.day_switch_tab}
        eventsAwayHome={widget?.events_away_home}
        settings={widget?.team_settings}
      />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default WidgetWeekEvents;
